module.exports = __webpack_public_path__ + "img/150.friend.00b63fe7.svg";